import {Controller, useFormContext} from "react-hook-form";
import type {SubSettingsFormFieldsType} from "../../types";
import {Checkbox, Space} from "antd";
import {FormFieldError} from "../../../../../../../design-system/form-field";

export function SubSettingsUrlRedirectCheckboxFormField({
  label = "Redirect customers to URL after purchase",
}: {
  label?: string;
}) {
  const {control, clearErrors} = useFormContext<SubSettingsFormFieldsType>();
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <Controller
          control={control}
          name="isUrlRedirect"
          render={({field: {onChange, value, ref}, fieldState: {error}}) => (
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <Checkbox
                onChange={(e) => {
                  clearErrors("url_redirect");
                  onChange(e.target.checked);
                }}
                ref={ref}
                checked={value}
              >
                {label}
              </Checkbox>
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      </Space>
    </div>
  );
}
